import {
    List,
    ListItem,
    ListItemText,
   Divider
 
} from '@mui/material'
import { htmlDecode } from './tools'


const ShopContentViewCard = ({item}) => {


    const listStyles = {
        color:'#000',
        fontsize: '24px',
        fontFamily: 'sans-serif',
      
        padding: '0px',
        margin: '0px'
      }
  



    return(
        <>
        <div>
      
        <List className='contentcard'>
        <Divider variant='inset' component="li"/>
              <ListItem>
                    


                    
                        <ListItemText style={listStyles} primary={item.title} />
                        
                    
                  </ListItem>

                  <div>
                  
                    

                        <div className='contentcard' dangerouslySetInnerHTML={
                            {__html: htmlDecode(item.shopContent
                            )}
                        }>
                           </div>
                        </div>
                        



                  <div>
              
                 
                
                            </div>
                <Divider className='mt-3 mb-3'/>
                </List>
                            </div>
                        
                        

                        

        </>
    )
}

export default ShopContentViewCard